import { useStore } from 'effector-react';
import { ButtonContainer } from 'features/fallback/ui/button-container';
import { Input } from 'features/fallback/ui/input';
import { css } from 'linaria';
import { sendEvent } from 'model/helpers/events.model';
import { link$ } from 'model/flows/fallback.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Button } from 'ui/atoms/button';

import { Container } from 'ui/container';
import { CheckIcon } from 'ui/icons/check-icon';
import { CopyIcon } from 'ui/icons/copy-icon';
import { LinkIcon } from 'ui/icons/link-icon';
import { Subtitle, Text } from 'ui/typography';

export const LinkCopyView = () => {
	const t = useLocalization();
	const link = useStore(link$);
	const [isCopied, changeIsCopied] = useState(false);
	const [start] = useState(Date.now());

	const handleCopy = () => {
		const input = document.getElementById('copy-email-input') as HTMLInputElement;
		input.removeAttribute('disabled');
		input.select();
		document.execCommand('copy');
		input.selectionStart = input.selectionEnd;
		changeIsCopied(true);
		input.setAttribute('disabled', 'true');

		sendEvent({
			event: 'link_copied',
			event_attributes: {
				duration: Date.now() - start,
			},
		});
	};

	useEffect(() => {
		screenHistoryPush(ScreenName.link);
		setTimeout(() => {
			sendEvent({
				event: 'link_screen_shown',
			});
		}, 20);
	}, []);
	useEffect(() => {
		if (isCopied) {
			screenHistoryPush(ScreenName.link_success);
		}
	}, [isCopied]);

	return (
		<Container>
			<Subtitle>{t('link.title')}</Subtitle>
			<Text className={textClass}>{t('link.description')}</Text>
			<Input
				id={'copy-email-input'}
				isEditing={false}
				icon={LinkIcon}
				value={link}
				inputClassName={inputClass}
				onChange={() => {}}
			/>
			<ButtonContainer style={{ marginTop: 16, width: '100%' }}>
				{isCopied ? (
					<Button
						name={'link.btn.success'}
						icon={<CheckIcon/>}
						type={'outline'}
						className={copiedButtonClass}
						style={{ width: '100%' }}
					>
						{t('link.btn.success')}
					</Button>
				) : (
					<Button
						name={'link.btn'}
						icon={<CopyIcon/>}
						onClick={handleCopy}
						style={{ width: '100%' }}
					>
						{t('link.btn')}
					</Button>)
				}
			</ButtonContainer>
		</Container>
	);
};

const textClass = css`
  margin-bottom: 20px;
	min-height: 44px;
`;
const inputClass = css`
  font-family: Menlo, sans-serif !important;
  font-size: 14px !important;
`;
const copiedButtonClass = css`
  color: var(--success-primary);
`;
